import { Env } from '@stencil/core';

export const APP_VERSION = Env.APP_VERSION;
